<div class="add-container">
    <h1 class="add-title">Adaugă stradă</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Nume</mat-label>
                    <input type="text" matInput formControlName="name" />
                    <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Țară</mat-label>
                    <mat-select formControlName="id_country" (openedChange)="onTaraSelectClosed()"
                        (selectionChange)="onTaraChange($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="tariControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredTari.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let tara of filteredTari" [value]="tara.id">
                            {{ tara.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_country'].valid && form.controls['id_country'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Județ</mat-label>
                    <mat-select formControlName="id_judet" (openedChange)="onJudeteSelectClosed()">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="judeteControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredJudete.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>

                        <mat-option *ngFor="let judet of filteredJudete" [value]="judet.id">
                            {{ judet.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_judet'].valid && form.controls['id_judet'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Localitate</mat-label>
                    <mat-select formControlName="id_localitate">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="localitatiControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="showLocalitatiMessage" disabled>
                            <span *ngIf="!localitatiControl.value || localitatiControl.value.length < 2">
                                Vă rugăm să introduceți 2 caractere sau mai multe
                            </span>
                            <span *ngIf="isLocalitatiLoading && localitatiControl.value.length >= 2">
                                Se caută...
                            </span>
                            <span
                                *ngIf="!isLocalitatiLoading && localitatiLoadComplete && localitati.length === 0 && localitatiControl.value && localitatiControl.value.length >= 2">
                                Nu s-au găsit rezultate
                            </span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let localitate of localitati" [value]="localitate.id">
                            {{ localitate.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_localitate'].valid && form.controls['id_localitate'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>